var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "search-input-text", class: _vm.getClassName() },
    [
      _c("dx-autocomplete", {
        ref: "dxAutocomplete",
        attrs: {
          "tab-index": 0,
          "data-source": _vm.autocomplete,
          placeholder: _vm.placeholder,
          value: _vm.value.Text,
          disabled: _vm.disabled,
        },
        on: {
          initialized: _vm.onInitialized,
          "value-changed": function ($event) {
            _vm.value.Text = $event.value
          },
          "enter-key": _vm.onEnter,
        },
      }),
      _vm.ready
        ? _c(_vm.icon, {
            tag: "component",
            attrs: { title: "" },
            on: { click: _vm.onEnter },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }